module.exports = __webpack_public_path__ + "static/media/Oval-filled.ef3a98b9.svg";